import React, { useEffect, useState } from 'react'
import { Table } from 'components/table'
import { IStuckLock } from 'types'
import api from 'helpers/api'
import { useApplicationStore } from 'hooks/application'
import Button from 'components/button'

const AdminLocks: React.FC = () => {
  const { displayErrorMessage } = useApplicationStore()

  const [stuckLocks, setStuckLocks] = useState<IStuckLock[]>()
  const [lastUpdate, setLastUpdate] = useState<Date>()

  const fetchStuckLocks = async () => {
    try {
      const response = await api.getStuckLocks()
      setStuckLocks(response.data)
      setLastUpdate(new Date())
    } catch (error) {
      displayErrorMessage(error)
    }
  }

  useEffect(() => {
    fetchStuckLocks()
    const intervalId = setInterval(fetchStuckLocks, 10000)
    document.title = 'Morta | Stuck Locks'
    return () => {
      clearInterval(intervalId)
    }
  }, [])

  const handleUnblock = (pid: number) => {
    if (window.confirm(`Are you sure you want to terminate database process PID ${pid}?`)) {
      api
        .cancelDbTransaction(pid.toString())
        .then(() => {
          fetchStuckLocks()
        })
        .catch((error) => {
          displayErrorMessage(error)
        })
    }
  }

  return (
    <div className="h-full w-full overflow-auto p-4">
      <p className="mb-8 mt-2.5">
        Data last updated: <b>{lastUpdate?.toLocaleString()}</b>, will fetch automatically every 10s
      </p>
      <Table
        data={
          stuckLocks !== undefined
            ? stuckLocks.map((lock) => {
                return {
                  pid: {
                    label: lock.pid,
                    value: lock.pid
                  },
                  usename: {
                    label: lock.usename ?? '',
                    value: lock.usename ?? ''
                  },
                  blockedQuery: {
                    label: lock.blockedQuery ?? '',
                    value: lock.blockedQuery ?? ''
                  },
                  blocking: {
                    label: (lock.blocking ?? []).map((blocker) => {
                      return (
                        <div key={blocker.pid}>
                          <span>
                            PID: {blocker.pid}, Query: {blocker.query}
                          </span>
                          <Button className="ml-2" internalType="danger" onClick={() => handleUnblock(blocker.pid)}>
                            Terminate Process
                          </Button>
                        </div>
                      )
                    }),
                    value: (lock.blocking ?? [])
                      .map((blocker) => {
                        return `PID: ${blocker.pid}, Query: ${blocker.query}`
                      })
                      .join(' ,')
                  }
                }
              })
            : []
        }
        loading={stuckLocks === undefined}
        include={[
          {
            header: 'PID',
            id: 'pid'
          },
          { header: 'Blocked Query', id: 'blockedQuery' },
          { header: 'Blocking', id: 'blocking' }
        ]}
        defaultSort={'pid'}
        defaultSortAscending={true}
        sort={true}
      />
    </div>
  )
}

export default AdminLocks
